/**
 * 此函数用于获取wood2模式下小猫板操作题的预置文件内容
 * @param {string} startWork 预置文件链接
 * @returns
 */
export async function getWood2CatBitPayload(startWork) {
  // 判断start_work是否是一个链接
  if (startWork.startsWith('http')) {
    try {
      // 将链接内容下载下来
      const response = await fetch(startWork)
      const content = await response.text()
      return JSON.parse(content)
    } catch (e) {
      console.error('wood2Cloud content error', e)
      return null
    }
  } else {
    return null
  }
}
